var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewAdmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.345337 33.7924V48.4421C0.345337 59.0143 8.9158 67.5848 19.488 67.5848H34.002H48.516C59.0882 67.5848 67.6587 59.0143 67.6587 48.4421V33.7924V19.1427C67.6587 8.57046 59.0882 0 48.516 0H34.002H19.488C8.91579 0 0.345337 8.57047 0.345337 19.1427V33.7924Z",
    fill: "#8280FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.531 26.281C23.531 29.5988 26.2099 32.2885 29.5144 32.2885C32.819 32.2885 35.4978 29.5988 35.4978 26.281C35.4978 22.9631 32.819 20.2734 29.5144 20.2734C26.2099 20.2734 23.531 22.9631 23.531 26.281ZM38.4895 32.2869C38.4895 34.7753 40.4986 36.7926 42.9771 36.7926C45.4555 36.7926 47.4646 34.7753 47.4646 32.2869C47.4646 29.7985 45.4555 27.7812 42.9771 27.7812C40.4986 27.7812 38.4895 29.7985 38.4895 32.2869Z",
    fill: "#8280FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4895 35.2969C22.4269 35.2969 16.6325 38.9412 16.0527 46.1092C16.0212 46.4997 16.7648 47.3119 17.14 47.3119H41.8503C42.974 47.3119 42.9914 46.404 42.974 46.1104C42.5356 38.741 36.6515 35.2969 29.4895 35.2969ZM45.3704 47.3118V47.316H51.1384C51.9499 47.316 51.9625 46.635 51.9499 46.4149C51.6369 40.9493 47.4779 38.3626 42.3836 38.3056C44.2592 40.8149 45.3704 43.9331 45.3704 47.3118Z",
    fill: "#8280FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAdmission);
export default __webpack_public_path__ + "static/media/newAdmission.6e7677e83053ab9a3dd28d6a039acb52.svg";
export { ForwardRef as ReactComponent };